import { TableNode } from '@lexical/table'
import { createCommand } from 'lexical'

import { TableMarkUpdatePayload } from './interface'

// 当前激活的 table 发生变化
export const ACTIVE_TABLE_CHANGE_COMMAND = createCommand<TableNode | undefined>(
  'ACTIVE_TABLE_CHANGE_COMMAND'
)

// table 尺寸变化，比如增加行数、列数，改变行高、列宽
export const TABLE_SIZE_CHANGE_COMMAND = createCommand<void>(
  'TABLE_SIZE_CHANGE_COMMAND'
)

// 设置 mark 样式
export const TABLE_MARK_UPDATE_COMMAND = createCommand<TableMarkUpdatePayload>(
  'TABLE_MARK_UPDATE_COMMAND'
)
